"use client";

import { RECOMMENDED_ENV_FAQ_LINK } from "@/app/config";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@medimo/ui";
import { useEffect, useState } from "react";

const FIREFOX_REGEX = /Firefox/i;

const isFirefox = () =>
  typeof navigator !== "undefined" && FIREFOX_REGEX.test(navigator.userAgent);

export const BrowserCheck = () => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (isFirefox()) {
      setShowError(true);
    }
  }, []);

  if (!showError) {
    return null;
  }

  return (
    <Dialog open={showError} onOpenChange={() => {}}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>お使いの環境はご利用いただけません</DialogTitle>
          <DialogDescription className="text-base leading-relaxed">
            詳しくは
            <a
              href={RECOMMENDED_ENV_FAQ_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline hover:text-blue-700"
            >
              medimoの推奨環境は？
            </a>
            をご覧ください。
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
